import Utility from "./utility";
import 'mmenu-js/dist/mmenu.js';
declare const Mmenu: any;

// interface RecentlyViewedProgram {
//     title: string;
//     url: string;
//     date: string;
// }

class Header {
    menuElement: HTMLElement;
    //sitewidebanner: HTMLElement | null;
    menu;
    utility = Utility;

    constructor() {
        this.init();
    }

    init() {
        // set up our universal constants
        const secondaryNav = document.querySelector('.secondary-nav') as HTMLElement | null;
        const bannerCloseButton = document.getElementById('sitewide-banner-close');
        const slideMenu = document.querySelector<HTMLElement>('.slide-menu');
            
        let sitewideBannerHeight: number;
        let secondaryNavHeight: number;
        let combinedHeight: number;
        let spacerHeight: number;
            
        let isBannerClosed = false;

        const infoDropdown: HTMLSelectElement = document.querySelector('.info-dropdown select');
        const infoDropdownBtn: HTMLButtonElement = document.querySelector('.info-dropdown button')

        // utility function to calculate the combined height of the sitewide banner and secondary nav
        function calculateCombinedHeight() {
            const sitewideBanner = document.querySelector('.sitewide-banner') as HTMLElement | null;
            sitewideBannerHeight = sitewideBanner ? sitewideBanner.clientHeight : 0;
            secondaryNavHeight = secondaryNav ? secondaryNav.clientHeight : 0;
            combinedHeight = window.innerWidth < 1200 ? sitewideBannerHeight : sitewideBannerHeight + secondaryNavHeight;
            spacerHeight = sitewideBannerHeight + secondaryNavHeight;

            const fixedMenuSpacer = document.querySelector('.fixed-menu-spacer') as HTMLElement | null;
            if (fixedMenuSpacer) {
                fixedMenuSpacer.style.height = `${spacerHeight}px`;
            }
        }

        // handle mobile menu top position dynamic value
        function setSlideMenuAttributes() {
            calculateCombinedHeight();
            
            const totalHeight =  secondaryNavHeight;
            const slideMenuHeight = window.innerHeight - totalHeight;

            const mobileNavCloseButtons = document.querySelectorAll<HTMLElement>('.mobile-nav-close');

            if (slideMenu) {
                const slideMenuTop = window.scrollY >= combinedHeight ? secondaryNavHeight + 1 : totalHeight + 1;
                slideMenu.style.top = `${slideMenuTop}px`;
                slideMenu.style.height = `${slideMenuHeight - 1}px`;
            }

            //this was causing close button to disapear when alert was present but I am assuming it was here for a reason so I just commented it out 
            //const closeButtonTop = window.scrollY >= combinedHeight || 18 ;
            const closeButtonTop = 18;
            mobileNavCloseButtons.forEach(btn => {
                //console.log(btn);
                btn.style.top = `${closeButtonTop}px`; 
            });
        }

        // handle insertion of the close button for the mobile menu
        function insertContentIntoBlockerElement(elementId: string, content: string): void {
            // First, select the element with the specified ID.
            const targetElement = document.getElementById(elementId);

            if (!targetElement) {
                console.error(`No element with ID "${elementId}" found.`);
                return; // Exit the function if the element is not found
            }

            // Set the innerHTML of the element with the provided content.
            // This will replace any existing content inside the element with the new content.
            targetElement.innerHTML = content;
        }

        function updateBlockerElementWithContent(): void {
            // Define the ID of the target element.
            const elementId = 'mm-0';

            // Define the content to be inserted.
            // Using a template literal here for clarity and multiline string.
            const newContent = `
                <span class="mobile-nav-close">
                    <span class="navbar-toggler-text">Close</span>
                    <ion-icon name="close-outline"></ion-icon>
                </span>
            `;

            // Call the function to insert content into the element.
            insertContentIntoBlockerElement(elementId, newContent);
        }

        // set the right position of '.mobile-nav-close' based on '#slide-nav-toggle'
        function setCloseButtonPosition(): void {
            // Select the reference element
            const referenceElement = document.getElementById('slide-nav-toggle');

            if (!referenceElement) {
                console.error('Reference element not found.');
                return; // Exit if the reference element isn't found
            }

            // Get the right position of the reference element relative to the viewport
            const rightPosition = window.innerWidth - referenceElement.getBoundingClientRect().right;

            // Iterate over all elements with the 'mobile-nav-close' class to adjust their 'right' position
            document.querySelectorAll<HTMLElement>('.mobile-nav-close').forEach(element => {
                element.style.right = `${rightPosition}px`;
            });
        }

        // handle close mobile menu button and toggle visibility based on the inert attribute of #mm-0.
        function handleMobileNavButtonVisibility(): void {
            const mobileNavToggleButton = document.getElementById('slide-nav-toggle') as HTMLElement;
            const mobileNavCloseButton = document.querySelector('.mobile-nav-close') as HTMLElement;
            const mm0Element = document.getElementById('mm-0');

            // Check if the elements exist
            if (!mobileNavToggleButton || !mm0Element) {
                console.error('Required elements not found.');
                return; // Exit the function early if the elements aren't found
            }

            // Create a MutationObserver to watch for changes in the 'inert' attribute
            const observer = new MutationObserver((mutationsList) => {
                // Loop through the mutations list to handle changes
                for (const mutation of mutationsList) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'inert') {
                        // Check if the 'inert' attribute is present and adjust visibility based on it
                        if (mm0Element.hasAttribute('inert')) {
                            // If 'inert' is present, make the button visible
                            mobileNavToggleButton.style.visibility = 'visible';
                            mobileNavCloseButton.style.display = 'none';
                        } else {
                            // If 'inert' is not present, hide the button
                            mobileNavToggleButton.style.visibility = 'hidden';
                            mobileNavCloseButton.style.display = 'inline-flex';
                        }

                        break; // If the relevant mutation is found and handled, we can break out of the loop
                    }
                }
            });

            // Configure the MutationObserver to watch for attribute changes
            observer.observe(mm0Element, { attributes: true });
        }

        // handle mobile menu backlinks classes
        function mobileMenuBacklinksClasses(): void {
            // handle mobile menu backlinks classes
            const mmNavbars = document.querySelectorAll('.mm-navbar');

            mmNavbars.forEach((mmNavbar) => {
                // Get the parent of the .mm-navbar element
                const parent = mmNavbar.parentElement;

                const primary = parent.querySelector('.primary');
                if (primary === mmNavbar.nextElementSibling) {
                    mmNavbar.classList.add('primary');
                }

                const secondary = parent.querySelector('.secondary');
                if (secondary === mmNavbar.nextElementSibling) {
                    mmNavbar.classList.add('secondary');
                }

                const tertiary = parent.querySelector('.tertiary');
                if (tertiary === mmNavbar.nextElementSibling) {
                    mmNavbar.classList.add('tertiary');
                }
            });
        }

        // handle mobile menu backlink content label
        function changeTextContentOfBacklinks(selector: string, newContent: string): void {
            // First, select all elements that match the given CSS selector.
            const elements = document.querySelectorAll(selector);

            // Iterate over every element and change its text content to the specified string.
            elements.forEach((element: Element) => {
            element.textContent = newContent;
            });
        }

        // handle classes for first and last instances of primary, secondary, tertiary <li> elements in mobile menu
        function assignFirstAndLastClasses(parentId: string, className: string): void {
            // Select the container element
            const container = document.getElementById(parentId);

            if (!container) {
                console.error(`No element with ID "${parentId}" found.`);
                return; // Exit the function if container is not found
            }
            
            // Get all the elements with the specific class
            const items = container.getElementsByClassName(className);

            if (items.length === 0) {
                console.log(`No elements with the class "${className}" found.`);
                return; // Exit the function if no elements are found
            }
            
            // Logic to add 'first' class, considering the 'label' exception
            for (let i = 0; i < items.length; i++) {
                const item = items[i] as HTMLElement; // As we're dealing with HTML elements

                // If it's the 'secondary' class and the item has a 'label' class, we skip
                if (className === 'secondary' && item.classList.contains('label')) {
                    continue; // Skip this item and continue with the next one
                }

                // If it's the first item that doesn't have 'label' (for 'secondary'), or any item for other classes
                if (item) {
                    item.classList.add('first');
                    break; // Exit the loop after marking the first valid item
                }
            }

            // Add 'last' class to the last element, if it exists
            if (items[items.length - 1]) {
                (items[items.length - 1] as HTMLElement).classList.add('last'); // Ensure it's treated as an HTMLElement
            }
        }

        // execute the function for the 'primary', 'secondary', and 'tertiary' classes
        function assignFirstLastClassesToElements(): void {
            const parentId = 'mm-1';
            const classes = ['primary', 'secondary', 'tertiary'];

            classes.forEach((className) => {
                assignFirstAndLastClasses(parentId, className);
            });
        }

        // handle equalization of dropdown heights for desktop nav
        function equalizeDropdownHeights() {
            // Handle main nav dropdown height equalization for child menus
            const topLevelDropdowns: NodeListOf<HTMLElement> = document.querySelectorAll('.main-nav .nav-item.dropdown');

            topLevelDropdowns.forEach(topDropdown => {
                // Getting the immediate submenu (direct child) using .dropdown-menu directly within topDropdown.
                const parentMenu: HTMLElement | null = topDropdown.querySelector('.main-nav .dropdown-menu');

                if (!parentMenu) return; // If no parent menu found, skip this iteration

                // Store the original styles of the parent menu
                const originalParentStyle = {
                    display: parentMenu.style.display,
                    visibility: parentMenu.style.visibility
                };

                // Temporarily set display:block and visibility:hidden to measure its height
                parentMenu.style.display = 'block';
                parentMenu.style.visibility = 'hidden';

                // Get the height of the parent menu using getBoundingClientRect
                const parentMenuHeight = parentMenu.getBoundingClientRect().height;

                // Reset the parent menu to its original styles
                parentMenu.style.display = originalParentStyle.display;
                parentMenu.style.visibility = originalParentStyle.visibility;

                // Getting the deeper nested submenus within the topDropdown
                const childSubmenus: NodeListOf<HTMLElement> = topDropdown.querySelectorAll('.main-nav .dropdown-submenu .dropdown-menu');

                // Set min-height of child submenus to the parent's height
                childSubmenus.forEach(childSubmenu => {
                    childSubmenu.style.minHeight = `${parentMenuHeight}px`;
                });
            });
        }

        // handle main nav desktop dropdowns potentially up to five levels -- top level items and up to 4 submenus deep -- including top position
        function desktopDropdownHandlers() {
            // Handle submenus
            document.querySelectorAll('.main-nav .dropdown-submenu a.dropdown-toggle').forEach((element: HTMLAnchorElement) => {
                element.addEventListener('click', (e: Event) => {
                    e.stopPropagation();
                    e.preventDefault();

                    const nextSibling = element.nextElementSibling as HTMLElement;
                    if (nextSibling) {
                        // Hide other submenus at the same level when one is clicked
                        element.closest('.dropdown-menu')?.querySelectorAll('.dropdown-menu.show').forEach((siblingSubmenu: HTMLElement) => {
                            if (siblingSubmenu !== nextSibling) {
                                siblingSubmenu.classList.remove('show');
                            }
                        });

                        // Calculate top position for the submenu
                        const mainNavBottom = (document.querySelector<HTMLElement>('.main-nav')?.getBoundingClientRect().bottom) || 0;
                        const toggleLinkTop = element.getBoundingClientRect().top;
                        const desiredTop = mainNavBottom - toggleLinkTop;
                        nextSibling.style.top = `${desiredTop}px`;

                        // Toggle clicked submenu
                        nextSibling.classList.toggle('show');
                    }
                });
            });

            // Handle top-level items
            document.querySelectorAll('.main-nav .nav-item.dropdown > a.dropdown-toggle').forEach((topLevelElement: HTMLAnchorElement) => {
                topLevelElement.addEventListener('click', () => {
                    // Hide all submenus when a top-level item is clicked
                    document.querySelectorAll('.main-nav .dropdown-submenu .dropdown-menu.show').forEach((submenu: HTMLElement) => {
                        submenu.classList.remove('show');
                    });
                });
            });
        }

        // adjust top position and height of various elements depending on whether parts of the nav around offscreen
        function adjustHeaderNav() {
            calculateCombinedHeight();
            const sitewideBanner = document.querySelector('.sitewide-banner') as HTMLElement | null;
            const sitewideBannerHeight = sitewideBanner ? sitewideBanner.clientHeight : 0;
            const totalHeight =  secondaryNavHeight;
            const slideMenuHeight = window.innerHeight - totalHeight;

            const headerNav = document.querySelector<HTMLElement>('.header-nav');
            const logoWrapper = document.querySelector('.main-nav .logo-wrapper');
            const mobileNavCloseButtons = document.querySelectorAll<HTMLElement>('.mobile-nav-close');
            
            if (headerNav) {
                let slideMenuTop: number;
                if (window.innerWidth < 1200 && isBannerClosed) {
                    headerNav.style.transform = 'translateY(0px)';
                    slideMenuTop = secondaryNavHeight + 1;
                } else if (window.scrollY >= combinedHeight) {
                    headerNav.style.transform = `translateY(-${combinedHeight}px)`;

                    if (logoWrapper) {
                        logoWrapper.classList.add('logo-show');
                    }
                    slideMenuTop = secondaryNavHeight + 1;
                } else {
                    headerNav.style.transform = `translateY(0px)`;
                    
                    if (logoWrapper) {
                        logoWrapper.classList.remove('logo-show');
                    }
                    slideMenuTop = totalHeight + 1;
                }

                if (slideMenu) {
                    slideMenu.style.top = `${slideMenuTop}px`;
                    slideMenu.style.height = window.scrollY >= combinedHeight ? `${slideMenuHeight + combinedHeight - 1}px` : `${slideMenuHeight - 1}px`;
                }

                //this was causing close button to disapear when alert was present but I am assuming it was here for a reason so I just commneted it out 
                //const closeButtonTop = window.scrollY >= combinedHeight || isBannerClosed ? 18 : sitewideBannerHeight + 18;
                const closeButtonTop = 18; 
                mobileNavCloseButtons.forEach(btn => {
                    btn.style.top = `${closeButtonTop}px`; 
                });
            }
        }

        // Debouncer and throttle functions for improved performance
        let debounceTimer;
        function debouncer(fn, delay = 250) {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => {
                fn();
            }, delay);
        }

        function throttle(func, wait) {
            let context, args, result;
            let previous = 0;

            return function() {
                let now;
                if ((now = Date.now() - previous) < wait) {
                    clearTimeout(context);
                    context = setTimeout(() => {
                        previous = now;
                        result = func.apply(this, args);
                    }, wait - now);
                } else {
                    previous = now;
                    result = func.apply(this, args);
                }
                return result;
            };
        }

        document.addEventListener('DOMContentLoaded', () => {
            // Initialize the mobile nav slide menu
            new Mmenu("#slide-nav", {
                navbar: {
                    title: "Menu"
                },
                offCanvas: {
                    position: "right-front"
                }
            });
            const sitewideBanner = document.querySelector('.sitewide-banner');

            calculateCombinedHeight();
            setSlideMenuAttributes();
            updateBlockerElementWithContent();
            setCloseButtonPosition();
            handleMobileNavButtonVisibility();
            mobileMenuBacklinksClasses();
            changeTextContentOfBacklinks('.mm-navbar__title span', 'Back');
            assignFirstLastClassesToElements();
            desktopDropdownHandlers();
            equalizeDropdownHeights(); // Call the function immediately to apply the heights
            adjustHeaderNav();

            // Event listeners
            document.addEventListener('closed', () => {
                isBannerClosed = true;
                calculateCombinedHeight();
            });

            // Window event listeners with debouncer
            window.addEventListener('resize', () => debouncer(() => {
                equalizeDropdownHeights();
                setSlideMenuAttributes();
                setCloseButtonPosition();
                adjustHeaderNav();
            }));
            
            window.addEventListener('scroll', throttle(adjustHeaderNav, 100));

            // This will trigger whenever the visual viewport changes, including when the address bar appears/disappears
            window.visualViewport.addEventListener('resize', () => {
                setSlideMenuAttributes();
                setCloseButtonPosition();
                adjustHeaderNav();
            });

            if (infoDropdownBtn != null) {
                infoDropdownBtn.addEventListener("click", function () {
                    window.open(infoDropdown.options[infoDropdown.selectedIndex].value, '_parent');
                })
            }
    
            if (infoDropdown != null) {
                infoDropdown.addEventListener("change", function (e) {
                    window.open((<HTMLOptionElement>e.target).value, '_parent');
                })
            }
        });
    }

    isMobile() {
        let vw = window.innerWidth;
        return vw <= 992;
    }

    goToPage(url) {
        window.open(url, '_parent');
    }
}

export default Header;